import type { SVGProps } from 'react';

const SvgSubtitleBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M10 11H17M7 15H14M4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19Z'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
    />
    <path
      d='M8 11C8 11.5523 7.55228 12 7 12C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10C7.55228 10 8 10.4477 8 11Z'
      fill='currentColor'
    />
    <path
      d='M18 15C18 15.5523 17.5523 16 17 16C16.4477 16 16 15.5523 16 15C16 14.4477 16.4477 14 17 14C17.5523 14 18 14.4477 18 15Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgSubtitleBd;
